import React, { useEffect, useState } from "react";
import styles from "./index.module.css";
import "react-tabs/style/react-tabs.css";
import { useNavigate } from "react-router-dom";
import DataTable_ from "common/DataTable";
import ContainerHeader from "common/ContainerHeader";
import { deleteData, getAll, updateData, SearchOptions } from "utils/queries";
import { formatDateFromDateAndTime } from "utils";
import Badge from "common/Badge";
import SelectSearch from "common/SelectSearch";

// Defined at module scope (not inside Ticket) so the function reference is stable
// across parent renders. RDT remounts the expanded row when this prop's reference
// changes, which would reset the inner DataTable_'s pagination state to page 1.
const ExpandedComponent = ({
  data,
  expandedData,
  expandedCount,
  expandableColumns,
  fetchAllTicketVariantsByTicketId,
  navigateToAddVariant,
}) => {
  return (
    <div style={{ paddingLeft: "20px" }}>
      {data?.variant_type === "variant" && (
        <div
          className={styles.addVariantButtonContainer}
          style={{
            marginBottom: "-10px",
            textAlign: "right",
            marginTop: "10px",
          }}
        >
          <Badge
            label="Add New Variant"
            style={{
              backgroundColor: "var(--primary-color)",
              color: "white",
            }}
            onClick={() => navigateToAddVariant(data.id)}
          />
        </div>
      )}
      <DataTable_
        columns={expandableColumns}
        data={expandedData}
        tableMinHeight={10}
        handlefetchData={fetchAllTicketVariantsByTicketId}
        totalCount={expandedCount}
      />
    </div>
  );
};

const Ticket = () => {
  const [expandedRows, setExpandedRows] = useState([]);
  const [expandedData, setExpandedData] = useState([]);
  const [expandedCount, setExpandedCount] = useState([]);
  const [expandedEvent, setExpandedEvent] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);

  console.log("expandedData", expandedData);

  const navigate = useNavigate();

  // const toggleRow = (id) => {
  //   // setExpandedRows((prevState) =>
  //   //   prevState.includes(id)
  //   //     ? prevState.filter((rowId) => rowId !== id)
  //   //     : [...prevState, id]
  //   // );
  //   setExpandedRows([id])
  // };

  const deleteMainTicket = async (ticketId) => {
    try {
      const result = await deleteData(`ticket/tickets?ticketId=${ticketId}`);
      fetchAllTickets_({});
      return result;
    } catch (error) {
      console.error("Error deleting ticket:", error);
    }
  };

  const toggleRow = (id) => {
    setExpandedRows((prevExpandedRows) =>
      prevExpandedRows.includes(id)
        ? prevExpandedRows.filter((rowId) => rowId !== id)
        : [id]
    );
  };

  // New function to navigate to create variant page
  const navigateToAddVariant = (ticketId) => {
    navigate(`/ticket/create-ticket?parentTicketId=${ticketId}`);
  };

  const navigateToDuplicateVariant = (parentTicketId, variantId) => {
    navigate(
      `/ticket/create-ticket?parentTicketId=${parentTicketId}&duplicateVariantId=${variantId}`
    );
  };

  const columns = [
    {
      name: "Ticket Name",
      cell: (row) => (
        <span
          onClick={() => toggleRow(row.id)}
          style={{ color: "var(--primary-color)", cursor: "pointer" }}
        >
          {row.ticket_name}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Location",
      selector: (row) => row.venue,
      sortable: true,
    },

    {
      name: "Count",
      selector: (row) => row.variant_count,
      sortable: true,
    },
    {
      name: "Quantity",
      selector: (row) => (
        // <div>{`${row?.current_quantity || 0} / ${row?.quantity || 0}`}</div>
        <div>{`${row?.tickets_sold || 0} / ${row?.quantity || 0}`}</div>
      ),
      sortable: true,
    },
    {
      name: "Start date",
      selector: (row) => formatDateFromDateAndTime(row.starts),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className={styles.actionButtons}>
          <Badge
            label="Delete"
            style={{ color: "red" }}
            onClick={() => deleteMainTicket(row.id)}
          />
        </div>
      ),
      sortable: false,
    },
  ];

  // const deleteTicket = async (ticketId) => {
  //   try {
  //     const result = await deleteData(`ticket/tickets/${ticketId}`);
  //     fetchAllTicketVariantsByTicketId({})
  //     return result
  //   } catch (error) {}
  // };

  const deleteTicket = async (ticketId, variantId) => {
    try {
      const result = await deleteData(
        `ticket/tickets?ticketId=${ticketId}&variantId=${variantId}`
      );
      fetchAllTicketVariantsByTicketId({});
      fetchAllTickets_({});
      return result;
    } catch (error) {
      console.error("Error deleting ticket:", error);
    }
  };

  const disableTicket = async ({ id, status }) => {
    try {
      const result = await updateData(`ticket/tickets/disable/${id}/${status}`);
      fetchAllTicketVariantsByTicketId({});
      return result;
    } catch (error) {}
  };

  const expandableColumns = [
    {
      name: "Name",
      selector: (row) => row.variant_name,
      sortable: true,
    },
    {
      name: "Ticket Price",
      selector: (row) => row.price,
      sortable: true,
    },
    {
      // name: "Revenue/Sale",
      name: "Quantity",
      selector: (row) => (
        // <div>{`${row?.current_quantity}/${row?.quantity_available}`}</div>
        <div>{`${row?.tickets_sold || 0} / ${row?.quantity_available || 0}`}</div>
      ),
      sortable: true,
    },
    // {
    //   name: "Sale",
    //   selector: (row) => row.sale,
    //   sortable: true,
    // },
    {
      name: "Revenue",
      selector: (row) => row.revenue,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => (row.is_active ? "Active" : "Inactive"), 
      sortable: true,
    },
    {
      name: "Actions",
      minWidth: "260px",
      cell: (row) => (
        <div className={styles.actionButtons}>
          <Badge
            label={row?.is_active ? "Hide" : "UnHide"}
            badgeClassOverride={styles.badgeClassOverride}
            onClick={() =>
              disableTicket({ id: row?.id, status: !row?.is_active, row })
            }
          />
          <Badge
            label="Edit"
            onClick={() => navigate(`/ticket/edit-ticket/${row?.id}`)}
            badgeClassOverride={styles.badgeClassOverride}
          />
          <Badge
            label="Duplicate"
            onClick={() => navigateToDuplicateVariant(expandedEvent, row?.id)}
            badgeClassOverride={styles.badgeClassOverride}
          />
          <Badge
            label="Delete"
            style={{ color: "red" }}
            // onClick={() => deleteTicket(row?.id)}
            onClick={() => deleteTicket(expandedEvent, row?.id)}
          />
        </div>
      ),
      sortable: true,
    },
  ];

  const [data, setData] = useState();
  const [totalCount, setTotalCount] = useState();

  const fetchAllTickets_ = async ({ limit = 10, offset = 0 }) => {
    try {
      let url = `ticket/tickets?limit=${limit}&offset=${offset}`;
      
      if (selectedEvent?.value) {
        url += `&event_id=${selectedEvent.value}`;
      }

      const result = await getAll(url);
      console.log("result is", result);
      const Data = result?.data?.data;
      if (Data?.rows) {
        setData(Data?.rows);
        setTotalCount(Data?.totalCount);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchAllTickets_({});
  }, [selectedEvent?.value]);

  const fetchOptions = async (search = "") => {
    try {
      let optionsResult;
      
      if (!search || search.trim() === "") {
        // Load all events (past and upcoming) when no search term
        optionsResult = await SearchOptions(`event/events?limit=100&offset=0`);
        return optionsResult?.data?.data?.rows?.map((e) => ({
          value: e?.id,
          label: e?.event_name,
        })) || [];
      } else {
        // Use search endpoint when user types
        optionsResult = await SearchOptions(`ticket/search?key=${search}`);
        return optionsResult?.data?.data
          ?.filter((e) =>
            e?.event_name?.toLowerCase().includes(search.toLowerCase())
          )
          ?.map((e) => ({ value: e?.id, label: e?.event_name })) || [];
      }
    } catch (error) {
      console.error("Error fetching options:", error);
      return [];
    }
  };

  const fetchAllTicketVariantsByTicketId = async ({
    ticket_id = expandedEvent,
    limit = 10,
    offset = 0,
  }) => {
    try {
      // const result = await getAll(`ticket/tickets/events/${ticket_id}`);
      const result = await getAll(
        `ticket/variants/${ticket_id}?limit=${limit}&offset=${offset}`
      );
      const data = result?.data?.data?.rows;
      const count = result?.data?.data?.totalCount;
      console.log("datais", data);
      if (data) {
        // setExpandedData((prev) => ({
        //   ...prev,
        //   [event_id]: Data?.rows,
        // }));
        setExpandedEvent(ticket_id);
        setExpandedData(data);
        setExpandedCount(count);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    // Fetch ticket data for all expanded rows
    expandedRows.forEach((rowId) => {
      if (!expandedData[rowId]) {
        setExpandedData([]);
        fetchAllTicketVariantsByTicketId({ ticket_id: rowId });
      }
    });
  }, [expandedRows]);

  return (
    <>
      <ContainerHeader
        label="Create Tickets"
        buttonFunction={() => navigate("./create-ticket")}
      />
      <div className={styles.container}>
        <div className={styles.filterWrapper}>
          <SelectSearch
            id="ticket-event-filter"
            placeholder="Select Event"
            value={selectedEvent}
            onChange={(val) => setSelectedEvent(val)}
            loadOptions={fetchOptions}
            formGroupStyleOverride={{ width: "25rem", marginBottom: "0" }}
          />
        </div>
        <DataTable_
          columns={columns}
          data={data}
          handlefetchData={fetchAllTickets_}
          totalCount={totalCount}
          expandableIcon={{ collapsed: null, expanded: null }}
          expandableRows
          // expandOnRowClicked={false}
          expandableRowsComponent={ExpandedComponent}
          expandableRowsComponentProps={{
            expandedData,
            expandedCount,
            expandableColumns,
            fetchAllTicketVariantsByTicketId,
            navigateToAddVariant,
          }}
          expandableRowExpanded={(row) => expandedRows.includes(row.id)}
          customStyles={{
            expanderCell: {
              style: {
                display: "none",
              },
            },
            expanderButton: {
              style: {
                display: "none",
              },
            },
          }}
        />
      </div>
    </>
  );
};

export default Ticket;
